// extracted by css-extract-rspack-plugin
export default {"currentValue":"src-modules-desktop-components-FpsPanel-FpsPanel-module__currentValue-T2YTnZ","currentUnit":"src-modules-desktop-components-FpsPanel-FpsPanel-module__currentUnit-ucjJJU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"currentValue\":\"src-modules-desktop-components-FpsPanel-FpsPanel-module__currentValue-T2YTnZ\",\"currentUnit\":\"src-modules-desktop-components-FpsPanel-FpsPanel-module__currentUnit-ucjJJU\"}";
        // 1793872695495
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  